// extracted by mini-css-extract-plugin
export default {"password":"identifier_password__8o0eJ"};